import PublicBuill from './publicBuill.js'
import examineTemplate from '../examineTemplate'

export default {
  components: {
    examineTemplate
  },
  props: {
    property: Object,
    view: String
  },
  data() {
    return {
      user: {},
      show: true,
      jjfksqd: {},
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      lcName: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], // 流程名称
      fybxdJmbxnrArr: [],
      examineTemplate: {
        workflowData: []
      },
      /*  */
      optionscwjzdw: [{
        label: '供应商',
        options: []
      }, {
        label: '客户',
        options: []
      }],
      djlbShow: false,
      djlbName: '',
      title: '',
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: '',
        flowId: '',
        maindjh: '',
        lb: '',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      saveUrl: '',
      jeDx: '',
      jeXx: ''
    }
  },
  created() {
    PublicBuill.setThis(this)
    this.initData(this.property)
  },
  methods: {
    initData(billDataAll) {
      this.user = localStorage
      this.jjfksqd = billDataAll.BillData
      this.jjfksqd.lrrId = localStorage.getItem('userNo')
      this.jeChange()
      this.jeXx = PublicBuill.formatAmount(this.jjfksqd.je)

      /* 审核使用字段 */
      this.oaSqdSh.maindjh = this.jjfksqd.djh
      this.oaSqdSh.flowId = this.jjfksqd.flowId
      this.oaSqdSh.shje = this.jjfksqd.je

      const djh = this.jjfksqd.djh.substring(0, 2)
      const rejected = this.jjfksqd.rejected === '1'
      const zdLcName = ['', '', '', '基建办负责人', '朗盛财务', '项目领导小组组长',
        '集团财务', '集团基建领导小组组长', '', '']
      if (djh === 'JM') {
        this.title = '基建项目付款申请单'
        this.lcName = ['', '', '审核会计', '基建办负责人', '财务部长',
          '基建领导小组组长', '财务总监', '集团日常经营管理小组', '', '']
        this.oaSqdSh.documentType = 'jmfksqd0'
        this.oaSqdSh.lb = 'jmfksqd'
        this.saveUrl = rejected ? '/fesback/fksqdJm/restartWorkflow.z' : '/fesback/fksqdJm/edit.z'
      } else if (djh === 'JN') {
        this.title = '基建项目设备付款申请单'
        this.lcName = ['', '', '审核会计', '公司董事长', '财务部长', '基建办负责人',
          '财务总监', '基建领导小组组长', '', '集团日常经营管理小组']
        this.oaSqdSh.documentType = 'jnfksqd0'
        this.oaSqdSh.lb = 'jnfksqd'
        this.saveUrl = rejected ? '/fesback/fksqdJn/restartWorkflow.z' : '/fesback/fksqdJn/edit.z'
      } else if (djh === 'ZM') {
        this.title = '铸锻产业园基建项目付款申请单'
        this.lcName = zdLcName
        this.djlbShow = true
        this.djlbName = '单据类别：铸锻产业园基建项目付款申请单'
        this.oaSqdSh.documentType = 'zdjmfksqd0'
        this.oaSqdSh.lb = 'zdjmfksqd'
        this.saveUrl = rejected ? '/fesback/fksqdJmDz/restartWorkflow.z' : '/fesback/fksqdJmDz/edit.z'
      } else if (djh === 'ZN') {
        this.title = '铸锻产业园基建项目设备付款申请单'
        this.lcName = zdLcName
        this.djlbShow = true
        this.djlbName = '单据类别：铸锻产业园基建项目设备付款申请单'
        this.oaSqdSh.documentType = 'zdjnfksqd0'
        this.oaSqdSh.lb = 'zdjnfksqd'
        this.saveUrl = rejected ? '/fesback/fksqdJnDz/restartWorkflow.z' : '/fesback/fksqdJnDz/edit.z'
      }
      this.examineTemplate.workflowData = []

      if (billDataAll.examineData) {
        const jnSHLC = {
          jnfksqd01: '公司董事长',
          jnfksqd02: '基建办负责人',
          jnfksqd03: '审核会计',
          jnfksqd04: '基建领导小组组长',
          jnfksqd05: '财务部长',
          jnfksqd06: '集团日常经营管理小组',
          jnfksqd07: '财务总监'
        }
        const jmSHLC = {
          jmfksqd01: '基建办负责人',
          jmfksqd02: '审核会计',
          jmfksqd03: '基建领导小组组长',
          jmfksqd04: '财务部长',
          jmfksqd05: '集团日常经营管理小组',
          jmfksqd06: '财务总监'
        }
        const zmSHLC = {
          zdjmfksqd01: '基建办负责人',
          zdjmfksqd02: '集团财务审批',
          zdjmfksqd03: '项目领导小组组长',
          zdjmfksqd04: '集团基建领导小组组长',
          zdjmfksqd05: '朗盛财务审核'
        }
        const znSHLC = {
          zdjnfksqd01: '基建办负责人',
          zdjnfksqd02: '集团财务审批',
          zdjnfksqd03: '项目领导小组组长',
          zdjnfksqd04: '集团基建领导小组组长',
          zdjnfksqd05: '朗盛财务审核'
        }
        for (let i = 0; i < billDataAll.examineData.length; i++) {
          const val = billDataAll.examineData[i]
          let nodeName = val.lcName
          if (val.lcName === '' || val.lcName === undefined || val.lcName === null) {
            const lcid = val.lcid
            if (djh === 'JM') {
              nodeName = jmSHLC[lcid]
            } else if (djh === 'JN') {
              nodeName = jnSHLC[lcid]
            } else if (djh === 'ZM') {
              nodeName = zmSHLC[lcid]
            } else if (djh === 'ZN') {
              nodeName = znSHLC[lcid]
            }
          }
          val.lcName = nodeName
          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }
          if (nodeName !== '经办人') {
            const receivedPersons = val.shr
            if (nodeName === '集团日常经营管理小组' && djh === 'JN') {
              this.lcPersons[9] = receivedPersons
            } else if (nodeName === '集团日常经营管理小组' && djh === 'JM') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '基建领导小组组长' && djh === 'JN') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '集团基建领导小组组长') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '集团财务审批' || nodeName === '财务总监') {
              this.lcPersons[6] = receivedPersons
            } else if (nodeName === '基建领导小组组长' && djh === 'JM') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '项目领导小组组长') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '基建办负责人' && val.djh === 'JN') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '财务部长' || nodeName === '朗盛财务审核') {
              this.lcPersons[4] = receivedPersons
            } else if (nodeName === '基建办负责人' && (djh === 'JM' || djh === 'ZM' || djh === 'ZN')) {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '公司董事长' && djh === 'JN') {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '审核会计') {
              this.lcPersons[2] = receivedPersons
            }
          }
          if (val.shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && nodeName !== '归档' && this.jjfksqd.recipient) {
            this.examineTemplate.workflowData.unshift({
              shr: this.jjfksqd.recipient,
              auditStatus: '未办理'
            })
          }
        }
      }
    },
    jjFksqdClose() {
      this.show = false
      this.$emit('jjFksqdClose')
    },
    agreeClick() {
      PublicBuill.agreeClick()
    },
    refuseClick() {
      PublicBuill.refuseClick()
    },
    queryBillData() {
      this.$emit('queryBillData')
      this.jjFksqdClose()
    },
    jeChange() {
      this.jeDx = PublicBuill.convertCurrency(this.jjfksqd.je)
    },
    save() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post(this.saveUrl, this.jjfksqd).then(response => {
        if (response.success) {
          this.$message.success(response.message)
          this.jjFksqdClose()
        } else {
          this.$message.error(response.message)
        }
        loading.close()
      }).catch(res => {
        loading.close()
        this.$message.error('非预期错误' + res)
      })
    },
    /* 财务记账单位 */
    remoteMethod(query) {
      if (query !== '') {
        this.optionscwjzdw[0].options = []
        this.optionscwjzdw[1].options = []
        const data = {
          subjectName: query
        }
        let url = '/fesback/fksqd/getFksqdGys.z'
        if (this.jjfksqd.djh.indexOf('Z')) {
          url = '/fesback/fksqd/getZDFksqdGys.z'
        }
        this.$post(url, data).then(response => {
          if (response !== undefined && response.length > 0) {
            response.forEach(value => {
              const item = {
              }
              item.code = value.subjectCode
              item.name = value.subjectName
              item.typeCode = value.typeCode
              if (value.typeCode !== null) {
                //item.khfl = value.typeCode
                this.optionscwjzdw[1].options.push(item)
              } else {
                this.optionscwjzdw[0].options.push(item)
              }
            })
          }
        })
      } else {
        this.optionscwjzdw[0].options = []
        this.optionscwjzdw[1].options = []
      }
    },
    changecwjzdw(event) {

      this.jjfksqd.hrdwmc = event.name
      this.jjfksqd.gys = event.name
      this.jjfksqd.gysbm = event.code
      if (event.typeCode !== null) {
        this.jjfksqd.gyslb = '0'
      } else {
        this.jjfksqd.gyslb = '1'
      }
    }


  }
}
